import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-r53  ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none transition',
  {
    variants: {
      variant: {
        default:
          'bg-gradient text-white p-3 hover:bg-btn/90 w-full uppercase font-semibold text-base shadow-renew active:scale-95 relative',
        plan: 'bg-green2 !py-1.5 !px-3 uppercase font-semibold active:scale-95 transition-all text-white w-full',
        outline: 'bg-transparent',
        secondary:
          'bg-[rgba(255,255,255,0.13)] text-white p-3 hover:bg-btn/90 w-full uppercase font-semibold text-base active:scale-95 relative',
      },
      size: {
        default: 'p-3',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
    )
  },
)
Button.displayName = 'Button'

export { Button, buttonVariants }
